<template>
  <div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div class="modal" v-if="modalShown && cellSpaceList.length"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>セル比率設定</h2>
        </div>
        <div class="input-area">
          <div v-if="errorMessage.text" class="error_message">
            {{ errorMessage.text }}<br>
            {{ fieldErrorMessages.size }}<br>
            {{ fieldErrorMessages.ratio }}
          </div>
          <div v-for="(errorMessage, idx) in errorMessages" :key="idx" class="error_message">
            {{ errorMessage }}
          </div>
          <div class="radio-area" v-if="setDoorAttSklFlg">
            <label>扉均等設定</label>
            <label><input type="radio" v-model="evenDoorFlg" :value="true">オン</label>
            <label><input type="radio" v-model="evenDoorFlg" :value="false">オフ</label>
          </div>
          <table v-if="isHorizontal" class="horizontal">
            <tr>
              <th class="label"></th>
              <th v-for="(cell, idx) in cellSpaceList" :key="cell.id">
                <span v-if="idx === 0">◀左セル</span>
                <span v-else-if="idx === (cellSpaceList.length - 1)">右セル▶</span>
              </th>
            </tr>
            <tr>
              <th class="label">サイズ固定</th>
              <td v-for="(cell, idx) in cellSpaceList" :key="cell.id">
                <input type="checkbox"  v-model="cell.isCheckedW" @change="checkFixSpace(idx)" :disabled="evenDoorFlg">
              </td>
            </tr>
            <tr>
              <th>ドア比率</th>
              <td v-for="(cell, idx) in cellSpaceList" :key="cell.id">
                <input type="number" min="0" step="0.001"
                :disabled="isNaN(cell.doorW) || cell.fixW || cell.isCheckedW || resizeCellList.length === 1 || evenDoorFlg"
                v-model.trim.number="cell.doorRatio"
                @input="onDoorRatioInput(idx)">
              </td>
            </tr>
            <tr>
              <th>ドアサイズ</th>
              <td v-for="(cell, idx) in cellSpaceList" :key="cell.id">
                <input type="number" min="0" step="0.001"
                :disabled="isNaN(cell.doorW) || cell.fixW || cell.isCheckedW || resizeCellList.length === 1 || evenDoorFlg"
                v-model.trim.number="cell.doorW "
                @input="onDoorSizeInput(idx)">
              </td>
            </tr>
            <tr>
              <th>セル比率</th>
              <td v-for="(cell, idx) in cellSpaceList" :key="cell.id">
                <input type="number" min="0" step="0.001"
                v-model.trim.number="cell.cellDivRatio"
                :disabled="cell.fixW || cell.isCheckedW || resizeCellList.length === 1 || evenDoorFlg"
                @input="onCellRatioInput(idx)">
              </td>
            </tr>
            <tr>
              <th class="low">セルサイズ</th>
              <td v-for="(cell, idx) in cellSpaceList" :key="cell.id">
                <!-- <span>{{ cell.w }}</span> -->
                <input type="number" min="0" :max="prevTotalCellSize" step="0.001"
                v-model.trim.number="cell.w"
                :disabled="cell.fixW || cell.isCheckedW || resizeCellList.length === 1 || evenDoorFlg"
                @input="onCellSizeInput(idx)">
              </td>
            </tr>
          </table>
          <table v-else>
            <tr>
              <th class="label"></th>
              <th class="size_fix">サイズ固定</th>
              <th>ドア比率</th>
              <th>ドアサイズ</th>
              <th>内寸</th>
              <th>比率(セル)</th>
              <!-- <th>セルサイズ</th> -->
            </tr>
            <tr v-for="(cell, idx) in cellSpaceList" :key="cell.id">
              <th>
                <span v-if="idx === 0">▲上セル</span>
                <span v-else-if="idx === (cellSpaceList.length - 1)">▼下セル</span>
              </th>
              <td class="size_fix">
                <input type="checkbox" v-model="cell.isCheckedH" @change="checkFixSpace(idx)">
              </td>
              <!-- ドア比率 -->
              <td>
                <input type="number" min="0" step="0.001"
                  v-model.trim.number="cell.doorRatio"
                  :disabled="isNaN(cell.doorH) || cell.fixH || cell.isCheckedH || resizeCellList.length === 1"
                  @input="onDoorRatioInput(idx)">
              </td>
              <!-- ドアサイズ -->
              <td>
                <input type="number" min="0" step="0.001"
                  v-model.trim.number="cell.doorH"
                  :disabled="isNaN(cell.doorH) || cell.fixH || cell.isCheckedH || resizeCellList.length === 1"
                  @input="onDoorSizeInput(idx)">
              </td>
              <!-- 内寸 -->
              <td>
                <input type="number" min="0" step="0.001"
                  v-model.trim.number="cell.innerH"
                  :disabled="cell.fixH || cell.isCheckedH || (cellSpaceList[idx+1] && cellSpaceList[idx+1].isOpenSpace) || resizeCellList.length === 1"
                  @input="onInnerSizeInput(idx)">
              </td>
              <!-- セル比率 -->
              <td>
                <input type="number" min="0" step="0.001"
                  v-model.trim.number="cell.cellDivRatio"
                  :disabled="cell.fixH || cell.isCheckedH || (cellSpaceList[idx+1] && cellSpaceList[idx+1].isOpenSpace) || resizeCellList.length === 1"
                  @input="onCellRatioInput(idx)">
              </td>
              <!-- セルサイズ -->
              <!-- <td style="text-align:center">{{ cell.h }}</td> -->
            </tr>
          </table>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="onOk">決定</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, KEY_CODE} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import * as SpaceUtil from '../../../utils/Space'
import * as SnapUtil from '../../../utils/Snap'
import * as CalcUtil from '../../../utils/Calc'
import {OBJECT_TYPE, PLANNING_TYPE, ATTRIBUTE_KEY, OBJECT_DTL_TYPE, VIEW_TYPE, FACE_TYPE} from '../../../constants/Type'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetCellRatioModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    editCtrlSpaces: Array,
    focusedMenuSpace: Object,
    isSelectedOneRelatedToShelfOnCanvas: Boolean,
    globalSpaceMap: Map
  },
  computed: {
    isHorizontal: function () {
      if (!this.cellSpaceList || this.cellSpaceList.length < 2) {
        return false
      }
      return this.cellSpaceList[0].x !== this.cellSpaceList[1].x
    }
  },
  data () {
    return {
      parentCellSpace: {},
      modalShown: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        size: '',
        ratio: ''
      },
      errorMessages: [],
      /** セル・棚空間リスト */
      modalSpaceList: [],
      /** セル空間リスト */
      cellSpaceList: [],
      /** リサイズ可能なセル空間リスト */
      resizeCellList: [],
      /** ドア空間IDリスト */
      doorSpaceIdList: [],
      /** セル比率合計 */
      totalCellRatio: 0,
      /** セルサイズ合計 */
      totalCellSize: 0,
      prevTotalCellSize: 0,
      /** ドア比率合計 */
      totalDoorRatio: 0,
      /** ドアサイズ合計 */
      totalDoorSize: 0,
      prevTotalDoorSize: 0,
      // 扉均等設定の条件を満たすか
      setDoorAttSklFlg: false,
      // 扉均等設定オン/オフ
      evenDoorFlg: false
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
        // this.$modal.show('modal')
      } else {
        this.$emit('setEditTargetCellSpaceParent', {})
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.cellSpaceList = []
      this.doorSpaceIdList = []
      if (this.focusedMenuSpace != null) {
        this.setParentCellSpace(this.focusedMenuSpace)
      } else if (this.isSelectedOneRelatedToShelfOnCanvas) {
        this.setParentCellSpace(this.editCtrlSpaces[0])
      }
      if (Object.keys(this.parentCellSpace).length) {
        // 親セル空間をフォーカスするためのセット
        this.$emit('setEditTargetCellSpaceParent', this.parentCellSpace)
        // セルと棚の情報を取得
        this.modalSpaceList = this.parentCellSpace.childrenSpaceModel
          .map(e => Object.assign({}, e))
        // セルの情報を取得
        this.cellSpaceList = this.parentCellSpace.childrenSpaceModel
          .filter(e => e.spaceObjectType === OBJECT_TYPE.CELL.code)
          .map(e => Object.assign({}, e))
        if (!this.cellSpaceList.length) {
          this.modalShown = false
          return
        }
        // ドアの情報を取得
        // 暫定対応：セル跨ぎの扉を含む場合は、ドア比率を非表示
        if (!this.isMultiCell()) {
          this.cellSpaceList
            .forEach(cell => {
              let doorParentSpace = this.getDoorSpace(cell)
              if (Object.keys(doorParentSpace).length) {
                cell.bottomSpace = doorParentSpace.h - cell.doorH
                cell.sideSpace = doorParentSpace.w - cell.doorW
                cell.doorWrapH = doorParentSpace.h - cell.h
                cell.doorWrapW = doorParentSpace.w - cell.w
                if (doorParentSpace.planningType === PLANNING_TYPE.UNIT_DOOR) {
                  this.doorSpaceIdList.push(doorParentSpace.id)
                }
              }
            })
        }
        // 並び変え
        this.modalSpaceList.sort((a, b) => this.isHorizontal ? (a.x - b.x) : (b.y - a.y))
        this.cellSpaceList.sort((a, b) => this.isHorizontal ? (a.x - b.x) : (b.y - a.y))
        // 比率の設定と合計算出
        this.totalCellRatio = 0
        this.cellSpaceList.forEach((space, idx) => {
          space.isOpenSpace = this.isDrawerAndOpenSpace(space)
          // セル比率
          let cellRatioAtt = this.fileData.attributeModelList.find(att => {
            return att.attKeycd === ATTRIBUTE_KEY.SP_CELL_RATIO && att.spaceId === space.id
          })
          if ((this.isHorizontal) || (!this.isHorizontal)) {
            space.cellDivRatio = cellRatioAtt ? CalcUtil.round(cellRatioAtt.attDouble1) : 1
          }
          // 合計比率の算出
          if (!isNaN(space.cellDivRatio)) {
            this.totalCellRatio += space.cellDivRatio
          }
          space.w = CalcUtil.round(space.w)
          space.h = CalcUtil.round(space.h)
          space.isCheckedW = cellRatioAtt.attValue1 === 1
          space.isCheckedH = cellRatioAtt.attValue2 === 1
          this.setInnerHeight(space, idx)
        })
        // 固定サイズ以外のセルをリストへ
        this.checkFixSpace()
        this.totalCellRatio = CalcUtil.round(this.totalCellRatio)
        // セルサイズ合計算出
        this.calcTotalSize()
        this.prevTotalCellSize = this.totalCellSize
        // ドアサイズ合計算出
        this.calcTotalDoorSize()
        this.prevTotalDoorSize = this.totalDoorSize
        this.calcDoorRatio()
      } else {
        AppUtil.showModal({
          messages: ['セル空間/固定棚を選択してください。']
        })
        this.modalShown = false
        return
      }
      this.setDoorAttSklFlg = this.isEvenDoorSetting()
      this.evenDoorFlg = false
      this.modalShown = true
    },
    setParentCellSpace (targetSpace) {
      const { planningType, childrenSpaceModel, parentSpaceId, spaceObjectType } = targetSpace
      switch (planningType) {
        case PLANNING_TYPE.COMBINE:
          // 直下のスケルトンの直下の、セル
          this.parentCellSpace = childrenSpaceModel[0].childrenSpaceModel.filter(space => space.spaceObjectType === OBJECT_TYPE.CELL.code)[0]
          break
        case PLANNING_TYPE.UNIT_SKELTON:
          // 直下のセル
          this.parentCellSpace = childrenSpaceModel.filter(space => space.spaceObjectType === OBJECT_TYPE.CELL.code)[0]
          break
        case PLANNING_TYPE.UNIT_SHELF:
          // 親空間のセル
          this.parentCellSpace = SpaceUtil.searchSpaceTree(parentSpaceId, this.fileData.topSpaceModel)
          break
        default:
          break
      }
      if (spaceObjectType === OBJECT_TYPE.CELL.code) {
        this.parentCellSpace = targetSpace
      }
    },
    /** 自身が引き出しを持つセルで、かつ上のセルと実際の空間が繋がっているかの判定 */
    isDrawerAndOpenSpace: function (cell, idx) {
      let drawer = cell.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_DRAWER)
      if (!drawer) { return false }
      // 一つ上の空間のindex
      let index = this.modalSpaceList.indexOf(this.modalSpaceList.find(space => space.id === cell.id)) - 1
      if (index < 0) { return false }
      let onTopUnit = this.modalSpaceList[index - 1].childrenSpaceModel[0]
      let isDrawerOnTop = onTopUnit ? onTopUnit.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_DRAWER.code : false
      // 上の棚がダミーで、かつ上に別の引き出しが接していない場合
      return this.modalSpaceList[index].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_CONST_.code && !isDrawerOnTop
    },
    /** 固定空間の変更があった場合の処理 */
    checkFixSpace: function (idx) {
      // リサイズ可能セルリストとセル比率の更新
      if (this.isHorizontal) {
        this.resizeCellList = this.cellSpaceList.filter(space => !space.fixW && !space.isCheckedW)
        this.calcTotalSize()
        this.cellSpaceList.forEach(space => {
          if (space.fixW || space.isCheckedW) {
            space.cellDivRatio = ''
          } else {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.w / this.totalCellSize)
          }
        })
      } else {
        this.resizeCellList = this.cellSpaceList.filter(space => !space.fixH && !space.isCheckedH)
        this.calcTotalSize()
        this.cellSpaceList.forEach(space => {
          if (space.fixH || space.isCheckedH) {
            space.cellDivRatio = ''
          } else {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.h / this.totalCellSize)
          }
        })
      }
      this.formatDivRatio()
      if (!idx && idx !== 0) return
      this.calcTotalSize()
      this.prevTotalCellSize = this.totalCellSize
      this.calcTotalDoorSize()
      // セル比率合計更新
      let ratioList = this.resizeCellList
        .map(space => space.cellDivRatio)
        .filter(num => !isNaN(num) && num)
      if (ratioList.length > 0) {
        this.totalCellRatio = CalcUtil.round(ratioList.reduce((a, b) => a + b))
      }
      this.calcDoorRatio()
    },
    /** 内寸変更時 */
    onInnerSizeInput: function (idx) {
      this.setHeightByInnerHeight(idx)
      this.cellSpaceList.forEach((space, index) => {
        if (idx !== index) {
          this.setInnerHeightBySize(space, index)
        }
      })
      this.setDoorSize()
      this.calcDoorRatio()
    },
    /** セルサイズ変更時 */
    onCellSizeInput: function (idx) {
      this.calcTotalSize()
      this.checkTotalSize(idx)
      this.setDoorSize()
      this.calcDoorRatio()
      if (this.isHorizontal) {
        this.cellSpaceList.forEach(space => {
          if (!space.fixW && !space.isCheckedW) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.w / this.totalCellSize)
          }
        })
      } else {
        this.cellSpaceList.forEach((space, idx) => {
          if (!space.fixH && !space.isCheckedH) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.h / this.totalCellSize)
            this.setInnerHeightBySize(space, idx)
          }
        })
      }
      this.formatDivRatio()
    },
    /** セル比率変更時 */
    onCellRatioInput: function (idx) {
      let ratioList = this.resizeCellList
        .map(space => space.cellDivRatio)
        .filter(num => !isNaN(num) && num)
      if (ratioList.length > 0) {
        this.totalCellRatio = CalcUtil.round(ratioList.reduce((a, b) => a + b))
      }
      if (this.isHorizontal) {
        this.cellSpaceList.forEach(space => {
          if (!space.fixW && !space.isCheckedW) {
            space.w = CalcUtil.round(this.prevTotalCellSize * space.cellDivRatio / this.totalCellRatio)
          } else {
            space.w = space.w
          }
        })
      } else {
        this.cellSpaceList.forEach((space, idx) => {
          if (!space.fixH && !space.isCheckedH) {
            space.h = CalcUtil.round(this.prevTotalCellSize * space.cellDivRatio / this.totalCellRatio)
          } else {
            space.h = space.h
          }
          this.setInnerHeightBySize(space, idx)
        })
      }
      // 比率再設定
      if (this.isHorizontal) {
        this.cellSpaceList.forEach((space, index) => {
          if (!isNaN(space.cellDivRatio) && index !== idx) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.w / this.totalCellSize)
          }
        })
      } else {
        this.cellSpaceList.forEach((space, index) => {
          if (!isNaN(space.cellDivRatio) && index !== idx) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.h / this.totalCellSize)
          }
          if (!isNaN(space.innerH)) {
            this.setInnerHeightBySize(space, index)
          }
        })
      }
      this.calcTotalSize()
      this.checkTotalSize(idx)
      this.setDoorSize()
      this.calcDoorRatio()
    },
    /** ドアサイズ変更時 */
    onDoorSizeInput: function (idx) {
      this.setCellSizeByDoorSize(idx)
      this.setDoorSize()
      this.calcDoorRatio()
    },
    /** ドア比率変更時 */
    onDoorRatioInput: function (idx) {
      let ratioList = this.resizeCellList
        .map(space => space.doorRatio)
        .filter(num => !isNaN(num) && num)
      if (ratioList.length > 0) {
        this.totalDoorRatio = CalcUtil.round(ratioList.reduce((a, b) => a + b))
      }
      this.prevTotalDoorSize = this.totalDoorSize
      if (this.isHorizontal) {
        this.resizeCellList
          .filter(space => space.doorRatio)
          .forEach(space => {
            space.doorW = CalcUtil.round(this.prevTotalDoorSize * space.doorRatio / this.totalDoorRatio)
          })
      } else {
        this.resizeCellList
          .filter(space => space.doorRatio)
          .forEach(space => {
            space.doorH = CalcUtil.round(this.prevTotalDoorSize * space.doorRatio / this.totalDoorRatio)
          })
      }
      this.setCellSizeByDoorSize(idx)
      // ドア比率再設定
      if (this.isHorizontal) {
        this.cellSpaceList.forEach((space, index) => {
          if (!isNaN(space.cellDivRatio) && index !== idx) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.w / this.totalCellSize)
          }
        })
      } else {
        this.cellSpaceList.forEach((space, index) => {
          if (!isNaN(space.doorRatio) && index !== idx) {
            space.doorRatio = CalcUtil.round(this.totalDoorRatio * space.doorH / this.totalDoorSize)
          }
        })
      }
      this.formatDivRatio()
    },
    /** 内寸からのセルの高さ設定 */
    setHeightByInnerHeight: function (idx) {
      // 高さのみ
      if (this.isHorizontal) return
      let cell = this.cellSpaceList[idx]
      // 上が空き空間の場合は、空き空間で調節
      if (cell.isOpenSpace) {
        idx -= 1
        this.cellSpaceList[idx].h = cell.innerH - cell.subInnerH
        // cell.h = CalcUtil.round(cellH - this.cellSpaceList[idx - 1].h)
      } else {
        if (cell.innerFixValue) {
          // 引き出しの場合は、内寸固定値からセルサイズを計算
          let cellH = cell.innerH + cell.innerFixValue
          cell.h = CalcUtil.round(cellH)
        } else {
          cell.h = cell.innerH
        }
      }
      // 合計値再算出
      this.calcTotalSize()
      if (this.cellSpaceList[idx].isOpenSpace) {
        // 上が空き空間のセルの変更は、１つ上のセルに振替
        this.checkTotalSize(idx - 1, true)
      } else {
        this.checkTotalSize(idx, true)
      }
      // 比率設定
      this.cellSpaceList.forEach(space => {
        if (!space.fixH && !space.isCheckedH) {
          space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.h / this.totalCellSize)
        }
      })
      this.formatDivRatio()
    },
    /** ドアサイズからセルのサイズを設定 */
    setCellSizeByDoorSize: function (idx) {
      if (this.isHorizontal) {
        this.cellSpaceList.forEach(space => {
          if (!isNaN(space.doorW)) {
            space.w = CalcUtil.round(space.doorW - space.doorWrapW + space.sideSpace)
          }
        })
      } else {
        this.cellSpaceList.forEach((space, idx) => {
          if (!isNaN(space.doorH)) {
            space.h = CalcUtil.round(space.doorH - space.doorWrapH + space.bottomSpace)
          }
        })
      }
      // 合計値再算出
      this.calcTotalSize()
      this.checkTotalSize(idx)
      // 比率設定
      if (this.isHorizontal) {
        this.resizeCellList.forEach(space => {
          if (!isNaN(space.cellDivRatio)) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.w / this.totalCellSize)
          }
        })
      } else {
        this.resizeCellList.forEach((space, idx) => {
          if (!isNaN(space.cellDivRatio)) {
            space.cellDivRatio = CalcUtil.round(this.totalCellRatio * space.h / this.totalCellSize)
          }
          if (!isNaN(space.innerH)) {
            this.setInnerHeightBySize(space, idx)
          }
        })
      }
      this.formatDivRatio()
    },
    /** 内寸設定 */
    setInnerHeightBySize: function (cell, idx) {
      let cellH = cell.h
      if (cell.isOpenSpace) {
        cellH = this.cellSpaceList[idx - 1].h + cell.h
      }
      // 内寸固定値を持つかどうか
      if (cell.innerFixValue) {
        cell.innerH = cellH - cell.innerFixValue
      } else {
        cell.innerH = cellH
      }
    },
    /** 初期の内寸を取得 */
    setInnerHeight: function (cell, idx) {
      // 高さのみ
      if (this.isHorizontal) return
      let globalCell = this.globalSpaceMap.get(VIEW_TYPE.FRONT).find(space => space.id === cell.id)
      let checkPointX = globalCell.x + globalCell.w / 2
      // 対象の引き出しの底板
      let globalBaseBoard = this.getGlobalBaseBoard(cell)
      if (!globalBaseBoard || !Object.keys(globalBaseBoard).length) {
        cell.innerH = cell.h
      } else {
        let targetSpaceList = []
        let sizeList = []
        this.globalSpaceMap.get(VIEW_TYPE.FRONT).forEach(space => {
          // 親空間
          let parent = SpaceUtil.getParentByCond(
            space,
            this.globalSpaceMap.get(VIEW_TYPE.FRONT),
            space => space.spaceObjectType === OBJECT_TYPE.UNIT.code
          )
          // 天板・棚板・底板を探す
          if ([OBJECT_DTL_TYPE.PART_TOP_BOARD.code, OBJECT_DTL_TYPE.PART_SHELF_BOARD.code, OBJECT_DTL_TYPE.PART_BASE_DRAWER.code].includes(space.spaceObjectDtlType)) {
            // 可動棚の棚板は対象外
            if (space.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_SHELF_BOARD.code &&
              parent.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_MOBILE_SHELF) {
              return
            }
            let target = space
            // 底板の場合は前板のUCに置き換える
            if (space.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_BASE_DRAWER.code) {
              let unitComp = parent.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_COMP_DOOR)
              target = SpaceUtil.getGlobalSpace(unitComp.id, this.globalSpaceMap)
            }
            if (checkPointX > target.x && checkPointX < target.x + target.w) {
              targetSpaceList.push(target)
            }
          }
        })
        targetSpaceList.map(space => {
        // 対象面からの距離が正ならリストに
          let faceDistance = CalcUtil.round(SnapUtil.getFacePosition(space, FACE_TYPE.BOTTOM) - (SnapUtil.getFacePosition(globalBaseBoard, FACE_TYPE.TOP)))
          if (!isNaN(faceDistance) && faceDistance > 0) {
            sizeList.push(faceDistance)
          }
        })
        let cellH = cell.h
        if (cell.isOpenSpace) {
          cellH = this.cellSpaceList[idx - 1].h + cell.h
        }
        // 対象面との距離と、セルサイズの差分を計算
        cell.innerH = sizeList.length ? sizeList.reduce((a, b) => a < b ? a : b) : cell.innerH
        cell.innerFixValue = cellH - cell.innerH
        if (cell.isOpenSpace) {
          cell.subInnerH = cell.innerH - this.cellSpaceList[idx - 1].h
        }
      }
    },
    /** 底板のグローバル座標取得 */
    getGlobalBaseBoard: function (cell) {
      if (!cell.childrenSpaceModel) return {}
      let drawer = cell.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_DRAWER)
      if (!drawer && cell.childrenSpaceModel.length) {
        drawer = cell.childrenSpaceModel
          .flatMap(childCell => childCell.childrenSpaceModel)
          .find(child => child.planningType === PLANNING_TYPE.UNIT_DRAWER)
      }
      if (!drawer) return {}
      let unitComp = drawer.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_COMP_INFILL)
      if (!unitComp) return {}
      // 底板
      let baseBoard = unitComp.childrenSpaceModel.find(child => child.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_BASE_DRAWER.code)
      if (!baseBoard) return {}
      // 底板
      let globalBaseBoard = SpaceUtil.getGlobalSpace(baseBoard.id, this.globalSpaceMap)
      return globalBaseBoard
    },
    /** セルと紐づくドア・引き出し空間取得 */
    getDoorSpace: function (cell) {
      if (cell.childrenSpaceModel.length) {
        let drawer = cell.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_DRAWER)
        if (!drawer && cell.childrenSpaceModel.length) {
          drawer = cell.childrenSpaceModel
            .flatMap(childCell => childCell.childrenSpaceModel)
            .find(child => child.planningType === PLANNING_TYPE.UNIT_DRAWER)
        }
        if (!drawer) return {}
        let unitComp = drawer.childrenSpaceModel.find(child => child.planningType === PLANNING_TYPE.UNIT_COMP_DOOR)
        if (!unitComp) return {}
        // 前板
        let wrapSpace = SpaceUtil.getWrapSpace(unitComp.childrenSpaceModel)
        cell.doorH = CalcUtil.round(wrapSpace.h)
        cell.doorW = CalcUtil.round(wrapSpace.w)
        return unitComp
      } else {
        // アトリビュート情報
        let linkedDoorAtt = this.fileData.attributeModelList.find(att => att.spaceId === cell.id && att.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_DOOR)
        if (!linkedDoorAtt) return {}
        // セルと紐づくユニット
        let linkedDoorSpace = SpaceUtil.getGlobalSpace(linkedDoorAtt.attValue1, this.globalSpaceMap)
        if (linkedDoorSpace.planningType === PLANNING_TYPE.UNIT_DOOR) {
          // ユニットの子供を包括する空間
          let wrapSpace = SpaceUtil.getWrapSpace(linkedDoorSpace.childrenSpaceModel)
          cell.doorH = wrapSpace.h
          cell.doorW = wrapSpace.w
          return linkedDoorSpace
        }
      }
      return {}
    },
    /** セル跨ぎのドア配置チェック */
    isMultiCell: function () {
      let doorIdList = []
      this.cellSpaceList.forEach(cell => {
        let linkedDoorAtt = this.fileData.attributeModelList.find(att => att.spaceId === cell.id && att.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_DOOR)
        if (linkedDoorAtt) {
          doorIdList.push(linkedDoorAtt.attValue1)
        }
      })
      let deplicateList = doorIdList.filter(function (x, i, self) {
        return self.indexOf(x) !== self.lastIndexOf(x)
      })
      return deplicateList.length > 0
    },
    /** ドアサイズ更新 */
    setDoorSize: function () {
      if (this.isHorizontal) {
        this.cellSpaceList.forEach(cell => {
          if (!isNaN(cell.doorW)) {
            cell.doorW = CalcUtil.round(cell.w + cell.doorWrapW - cell.sideSpace)
          }
        })
      } else {
        this.cellSpaceList.forEach(cell => {
          if (!isNaN(cell.doorH)) {
            cell.doorH = CalcUtil.round(cell.h + cell.doorWrapH - cell.bottomSpace)
          }
        })
      }
    },
    /** 合計セルサイズ算出 */
    calcTotalSize: function () {
      let cellSizeList = this.resizeCellList
        .map(space => this.isHorizontal ? space.w : space.h)
        .filter(num => !isNaN(num) && num)
      if (cellSizeList.length > 0) {
        this.totalCellSize = cellSizeList.reduce((a, b) => a + b)
      }
    },
    /** 合計サイズチェック */
    checkTotalSize: function (idx, innerHFlg) {
      if (this.totalCellSize === this.prevTotalCellSize) return
      const invalidTotalSize = this.totalCellSize
      this.totalCellSize = this.prevTotalCellSize
      // 合計値が一致しない場合は、端数を他のセルに分配
      let distributeCell = this.cellSpaceList[idx]
      let distributeCellList = this.resizeCellList
      // 内寸変更時は、上が空き空間のセルは対象外
      if (innerHFlg) {
        distributeCellList = this.resizeCellList.filter(space => !space.isOpenSpace)
      }
      // リサイズリスト内でのindex
      let index = distributeCellList.indexOf(distributeCellList.find(cell => cell.id === distributeCell.id))
      if (this.isHorizontal) {
        for (let i = index; i <= distributeCellList.length; i++) {
          index = i === distributeCellList.length - 1 ? --index : ++index
          if (distributeCellList.length === 1) {
            distributeCell = distributeCellList[0]
          } else {
            distributeCell = distributeCellList[index]
          }
          distributeCell.w = CalcUtil.round(distributeCell.w + this.prevTotalCellSize - invalidTotalSize)
          distributeCell.cellDivRatio = CalcUtil.round(this.totalCellRatio * distributeCell.w / this.totalCellSize)
          break
        }
      } else {
        for (let i = index; i <= distributeCellList.length; i++) {
          // 上セルに分配していく
          index = i === 0 ? ++index : --index
          if (distributeCellList.length === 1) {
            distributeCell = distributeCellList[0]
          } else {
            distributeCell = distributeCellList[index]
          }
          distributeCell.h = CalcUtil.round(distributeCell.h + this.prevTotalCellSize - invalidTotalSize)
          distributeCell.cellDivRatio = CalcUtil.round(this.totalCellRatio * distributeCell.h / this.totalCellSize)
          break
        }
      }
    },
    /** 合計ドアサイズ算出 */
    calcTotalDoorSize: function () {
      this.totalDoorSize = 0
      this.resizeCellList
        .map(space => this.isHorizontal ? space.doorW : space.doorH)
        .filter(num => !isNaN(num) && num)
        .forEach(num => {
          this.totalDoorSize = CalcUtil.round(this.totalDoorSize + num)
        })
    },
    /** ドア比率設定 */
    calcDoorRatio: function () {
      this.totalDoorRatio = 1
      this.cellSpaceList.forEach(cell => {
        if (this.isHorizontal && !isNaN(cell.doorW)) {
          if (cell.fixW || cell.isCheckedW) {
            cell.doorRatio = ''
          } else {
            cell.doorRatio = cell.doorW / this.totalDoorSize * this.totalDoorRatio
          }
        } else if (!this.isHorizontal && !isNaN(cell.doorH)) {
          if (cell.fixH || cell.isCheckedH) {
            cell.doorRatio = ''
          } else {
            cell.doorRatio = cell.doorH / this.totalDoorSize * this.totalDoorRatio
          }
        }
      })
      this.formatDoorRatio()
    },
    /** セル比率正規化 */
    formatDivRatio: function () {
      let firstCellRatio = 0
      this.resizeCellList.forEach(space => {
        if (firstCellRatio === 0) {
          firstCellRatio = space.cellDivRatio
        }
        space.cellDivRatio = CalcUtil.round(space.cellDivRatio / firstCellRatio)
      })
    },
    /** ドア比率正規化 */
    formatDoorRatio: function () {
      let cellLinkedDoorList = this.cellSpaceList.filter(space => !isNaN(space.doorRatio) && space.doorRatio !== '')
      let firstDoorRatio = 0
      if (!cellLinkedDoorList) return {}
      cellLinkedDoorList.forEach(space => {
        if (firstDoorRatio === 0) {
          firstDoorRatio = space.doorRatio
        }
        space.doorRatio = CalcUtil.round(space.doorRatio / firstDoorRatio)
      })
    },
    /** 設定ボタン押下時 */
    onOk: function (event) {
      if (!this.modalShown) return
      event.preventDefault()
      this.clearMessages()
      this.setCellRatio()
    },
    /** キャンセルボタン押下時 */
    onCancel: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** enter/escキー押下時 */
    onKeydown: function (event) {
      if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.keyCode === KEY_CODE.ENTER) {
        if (Object.keys(this.parentCellSpace).length) {
          this.onOk(event)
        } else {
          this.onCancel(event)
        }
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancel(event)
      }
    },
    /** 扉均等設定の条件を満たすか判定 */
    isEvenDoorSetting: function () {
      let skl = SpaceUtil.searchSpaceTree(this.parentCellSpace.parentSpaceId, this.fileData.topSpaceModel)
      // スケルトン直下セル
      let setFlg = skl.planningType === PLANNING_TYPE.UNIT_SKELTON
      // 中仕切りあり
      let separator = this.modalSpaceList.find(space => space.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_INNER_SEPARATOR.code)
      setFlg = setFlg && separator != null
      // セル階層は1段のみ
      this.cellSpaceList.forEach(cell => {
        let childCell = cell.childrenSpaceModel.filter(child => child.spaceObjectType === OBJECT_TYPE.CELL.code).length
        if (childCell > 0) {
          setFlg = false
        }
      })
      // 扉3枚以上
      let doorCount = 0
      this.doorSpaceIdList.forEach(id => {
        let door = SpaceUtil.getGlobalSpace(id, this.globalSpaceMap)
        doorCount += door.childrenSpaceModel.filter(child => child.spaceObjectType === OBJECT_TYPE.PARTS.code).length
      })
      setFlg = setFlg && doorCount > 2
      return setFlg
    },
    /** セル比率更新 */
    setCellRatio: function () {
      if (!this.isHorizontal && !this.evenDoorFlg) {
        this.cellSpaceList.forEach(space => {
          if (space.innerH <= 0) {
            this.errorMessage.text = '入力エラーがあります'
            this.fieldErrorMessages.size = '内寸は0より大きい値を指定してください。'
          } else if (space.doorH <= 0) {
            this.errorMessage.text = '入力エラーがあります'
            this.fieldErrorMessages.size = 'ドアサイズは0より大きい値を指定してください。'
          }
        })
      }
      if (this.errorMessage.text) return
      let payload = {
        evenDoorFlg: this.evenDoorFlg,
        sklSpaceId: this.parentCellSpace.parentSpaceId,
        doorSpaceIds: this.setDoorAttSklFlg ? this.doorSpaceIdList : [],
        parentCellSpaceId: this.parentCellSpace.id,
        cellSpaceList: this.cellSpaceList.map(e => {
          return {
            cellSpaceId: e.id,
            w: e.w,
            h: e.h,
            isCheckedW: e.isCheckedW,
            isCheckedH: e.isCheckedH
          }
        })
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/cell-ratio', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.$emit('closeTreeContextModal')
            this.modalShown = false
            this.clearMessages()
            this.cellSpaceList = []
            this.doorSpaceIdList = []
            this.$emit('setResponseData', response)
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        size: '',
        ratio: ''
      }
      this.errorMessages = []
    }
  }
}
</script>

<style scoped lang="scss">
.input-area {
  overflow: auto;
  max-height: calc(100% - 110px);
  .radio-area {
    height: 50px;
    font-weight: bold;
    text-align: left;
    padding: 0px 80px;
    label {
      margin: 10px;
    }
  }
}
table, tr, th, td {
  border: 0;
}
table {
  tr {
    th {
      text-align: center;
      background: unset;
    }
    th, td {
      padding: 0;
      line-height: inherit;
      width: 120px;
      input {
        width: calc(100% - 27px);
        margin-bottom: 1px;
      }
      &.label {
        width: 50px;
      }
      &.low {
        line-height: 1;
      }
    }
    .size_fix {
      width: 50px;
    }
  }
}
.modal .modal-main {
  width: 60%;
  max-width: 80%;
}
.modal .modal-main .input-area {
  text-align: center;
  padding: 10px 0px;
}
.error_message {
  line-height: 1;
  text-align: left;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetCellRatioModal.vue